import axios from "@/api/axios"
import {apiUrlWithLang} from "@/helpers/persistanceStorage";
const getProductsViewed = credentials => {
    let url = apiUrlWithLang('/dashboard/api/products/variations/viewed')
    return axios.get(url, { params:credentials })
}

const getProductsWishlist = credentials => {
    let url = apiUrlWithLang('/dashboard/api/products/variations/wishlist')
    return axios.get(url, { params:credentials })
}

export default {
    getProductsViewed,
    getProductsWishlist,
}